import { render, staticRenderFns } from "./AutoRunPointValConfigModal.vue?vue&type=template&id=274eabc8&"
import script from "./AutoRunPointValConfigModal.vue?vue&type=script&lang=js&"
export * from "./AutoRunPointValConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports